module.exports = __webpack_public_path__ + "static/media/Planshero.2227ab7a.jpg";